

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PopUp from '../../../../Shared/Popup/PopUp';
import { getCreditDataAsync } from '../../PersonalAreaInvoicesAsyncThunk';

function Credit(props) {
  const [showPopUp, setShowPopUp] = useState(false);

  if (!props.dalCredit?.isCreditExists) {
    return null;
  }

  async function handleShowPopUp(isDisplayPopUp) {
    if (!isDisplayPopUp) {
      setShowPopUp(false);
      return;
    }

    if (Object.keys(props.refoundDetails).length === 0) {
      const details = await props.getCreditDataAsync();
      if (!details.payload) return;
    }

    setShowPopUp(true);
  }

  return (
    <>
    <div className='credit'>
      <div>החודש קיבלת זיכוי לאמצעי התשלום בסכום של&nbsp;
        <span>
         ₪{props.dalCredit.amount}.{props.dalCredit.amountAgorot}
         {props.dalCredit.isAmountMinus && <span className='price-range'>-</span> }
        </span>
        <button onClick={() => handleShowPopUp(true)} className='credit-invoice-btn'> לצפייה בחשבונית זיכוי</button>
      </div>
    </div>
    <PopUp
        className='refound-popup'
        showPopUp={showPopUp}
        onClose={() => handleShowPopUp(false)}>
        <div className='refound-popup-wrapper'>
          <h2>הודעת זיכוי <span>העתק</span></h2>
          <div><span className='text'>הודעת זיכוי מספר: </span><span className='text-bold'>{props.refoundDetails.invoiceNumber}</span></div>
          <div><span className='text'>תאריך חשבון: </span><span className='text-bold'>{props.refoundDetails.date}</span></div>
          <div><span className='text'>לכבוד: </span><span className='text-bold'>{props.refoundDetails.fullName}</span></div>
          <div className='text refoundText'>{props.refoundDetails.refoundText}</div>
          <div className='refound-details-wrapper'>
            <div className='title'>פירוט זיכויים</div>
            {props.refoundDetails?.refoundPrice?.priceBeforeTax.map((item, index) => {
              return (<div key={index} className='refound-row'><span className='text'>{item.text} (לפני מע"מ)</span><span className='price'>{item.price}</span></div>)
            })}
            <div className='refound-row'><span className='text'>{props.refoundDetails?.refoundPrice?.tax?.text}</span><span className='price'>{props.refoundDetails?.refoundPrice?.tax?.price}</span></div>
            <div className='refound-row summary'><span className='text'>סה״כ</span><span className='price'>{props.refoundDetails?.refoundPrice?.priceAfterTax}</span></div>
          </div>
          <div className='footer-text'>{props.refoundDetails.footerText}</div>
        </div>
      </PopUp>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    dalCredit: state.personalAreaInvoicesPage?.invoicesInfo?.dalCredit,
    refoundDetails: state.personalAreaInvoicesPage?.refoundDetails,
  };
};
const mapDispatchToProps = {
  getCreditDataAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(Credit);
